import { render, staticRenderFns } from "./FabricProcessIndex.vue?vue&type=template&id=8ce1ef6c&scoped=true&"
import script from "./FabricProcessIndex.vue?vue&type=script&lang=js&"
export * from "./FabricProcessIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce1ef6c",
  null
  
)

export default component.exports